import React from 'react';
import { obterContratoPeloNumero } from '../actions/ContratoActions';
import { obterArrobasPeloContrato } from '../actions/InstagramActions';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import MapaServices from '../services/mapa';

class ContratosInfo extends React.Component {
  state = {
    contrato: "",
    contratoEncontrato: {},
    exibirInformacoes: false,
    carregando: false
  }

  getContrato (e) {
    e.preventDefault();
    this.setState({exibirInformacoes: false, carregando: true});
    this.props.obterContratoPeloNumero(this.state.contrato).then(() => {
      this.props.obterArrobasPeloContrato(this.props.contrato.id).then(async () => {
        let mapa = new MapaServices(),
          contrato = Object.assign({}, this.props.contrato);
        await mapa.getTabela(contrato.numOrcamento).then((orcamento) => {
          contrato.curso = orcamento.curso !== undefined ? orcamento.curso : "Indisponível";
          this.setState({exibirInformacoes: true, carregando: false, contratoEncontrado: contrato});
        }).catch(() => {
          contrato.curso = "Indisponível";
          this.setState({exibirInformacoes: true, carregando: false, contratoEncontrado: contrato});
        });
      }).catch(() => { 
        this.setState({carregando: false});
        toast.error("Não foi possível localizar os @s deste contrato!");
      });
    }).catch(() => { 
      this.setState({carregando: false});
      toast.error("Não foi possível obter as informações do contrato digitado. Ele pode não existir ou não estar cadastrado no sistema da Agência");
    });
  }

  _renderExibirInformacoes () {
    return (
      <div className="box">
        <div className="box-body">
          <h3 >Dados gerais:</h3>
          <ul className="list-group">
            <li className="list-group-item">Numero do Contrato:<span className="pull-right">{this.state.contratoEncontrado.numero}</span></li>
            <li className="list-group-item">Data de Formatura:<span className="pull-right">{this.state.contratoEncontrato.dataFormatura !== undefined ? this.state.contratoEncontrado.dataFormatura.split("T")[0].split("-").reverse().join("/") : "Indisponível"}</span></li>
            <li className="list-group-item">Curso:<span className="pull-right">{this.state.contratoEncontrado.curso}</span></li>
            <li className="list-group-item">Email:<span className="pull-right">{this.state.contratoEncontrado.emailComissao}</span></li>
            <li className="list-group-item">Gestor(a) contratual:<span className="pull-right">{this.state.contratoEncontrado.dono.nome}</span></li>
          </ul>
          <br/>
          <div className="row">
            <div className="col-sm-12 col-md-6">
              <h3>Instagram</h3>
              <div className="table-responsive">
                <table id="datatableInstagram" className="table table-striped">
                  <thead>
                    <tr>
                      <th>Instagram</th>
                    </tr>
                  </thead>
                  <tbody>
                  {
                    this.props.instagram.length > 0 ?
                      this.props.instagram.map((arroba) => (
                        <tr key={arroba.id}>
                          <td>
                            {arroba.descricao}
                          </td>
                        </tr>
                      ))
                    :
                    <tr><td>Nenhum @ cadastrado</td></tr>
                  }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        <div className="box">
          <div className="box-body">
            <h3 style={{ color: "rgba(0, 0, 0, 0.85)" }}>Buscar contrato</h3>
            <form onSubmit={this.getContrato.bind(this)}>
              <div className="input-group">
                <input type="number" value={this.state.contrato} placeholder="Número do contrato" min="0" onChange={(event) => this.setState({ contrato: event.target.value })} className="form-control" />
                <div className="input-group-btn">
                  <button type="submit" className="btn btn-flat btn-primary">Buscar contrato</button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <br/>
        {
          this.state.carregando && !this.state.exibirInformacoes ?
            <h4 style={{textAlign: "center"}}>Carregando <i className="fa fa-spinner fa-pulse fa-fw"></i> </h4>
          : !this.state.carregando && this.state.exibirInformacoes ?
              this._renderExibirInformacoes()
            : null
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario.autenticado,
    contrato: state.contrato.especifico,
    instagram: state.instagram.todos
  }
}

export default connect(mapStateToProps, { obterContratoPeloNumero, obterArrobasPeloContrato })(ContratosInfo);



// WEBPACK FOOTER //
// ./src/views/ContratosInfo.js